import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
export default class InitiativesUpdateWizardComponent extends Component {
  @tracked activeStep = 0;

  @service betaToggle;
  @service router;
  @service initiativeSlideover;

  @action
  setActiveStep(index) {
    this.activeStep = index;
  }

  @action
  closeWizard() {
    this.activeStep = 0;
    this.initiativeSlideover.closeWizard();
  }

  get initiative() {
    return this.initiativeSlideover.initiative;
  }
}
